import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, readonly, provide, onMounted, onUnmounted } from 'vue'
import { NDropdown } from 'naive-ui'
import { contextMenuInjectionKey } from './context'
import type { UnwrapNestedRefs } from 'vue'
import type { ShowOptions, ContextMenuProvider } from './types'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContextMenuProvider',
  setup(__props) {

const visible = ref(false)
const options = ref<ShowOptions | null>(null)

const menus = computed(() => options.value?.menus)
const x = computed(() => options.value?.x ?? 0)
const y = computed(() => options.value?.y ?? 0)
const select = computed(() => options.value?.onSelect)
const handleKeyBoard = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    close()
  }
}
const show = (params: ShowOptions) => {
  visible.value = true
  options.value = params as UnwrapNestedRefs<ShowOptions>
}

const close = () => {
  visible.value = false
}

const provider: ContextMenuProvider = {
  visible: readonly(visible),
  show,
  close
}
onMounted(() => {
  document.addEventListener('keydown', handleKeyBoard)
})
onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyBoard)
})

provide(contextMenuInjectionKey, provider)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(NDropdown), {
      placement: "bottom-start",
      trigger: "manual",
      x: _unref(x),
      y: _unref(y),
      options: _unref(menus),
      show: visible.value,
      "on-clickoutside": close,
      onSelect: _unref(select),
      class: "dropdown--default"
    }, null, 8, ["x", "y", "options", "show", "onSelect"])
  ], 64))
}
}

})